import 'styles/Header.less'
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import moment from 'moment'
import classNames from 'classnames'
import Menu from './Menu'
import assets from 'modules/assets'
import * as actions from '../../actions'

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ...props,
      menuState: false,
      alertIsMinimized: false,
      headerIsHidden: false,
      isNavigateGallery: false,
      top: 80
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      ...nextProps
    })
  }
  toggleMenu = () => {
    this.props.dispatch(actions.token.toggleMenu(!this.state.menuState))
  }

  render() {
    let fixPosition = {
      top: this.state.scrollY <= 80 ? this.state.top - this.state.scrollY + 'px' : '0px'
    }
    if (this.state.alertIsMinimized)
      fixPosition.top = 0

    return (
      <div className='header-component' style={fixPosition} >
        <section className="main-grid">
          <ul className="grid group">
            <li className="grid-small">
              <div className='header-menu' onClick={this.toggleMenu}>
                <i className="fa fa-bars" aria-hidden="true"></i>
              </div>
            </li>
            <li className="grid-small grid-middle">
              <Link className='logo' to='/'>
                <img src={assets('images/logos/gakko-logo.png')}/>
              </Link>
            </li>
          </ul>
        </section>
      </div>
    )
  }
}
Header.contextTypes = {
}
Header.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    menuState: state.token.menuState,
    alertIsMinimized: state.token.alertIsMinimized,
    headerIsHidden: state.token.headerIsHidden,
    isNavigateGallery: state.token.isNavigateGallery
  }
}

export default connect(mapStateToProps)(Header)



// WEBPACK FOOTER //
// ./src/components/Utils/Header.js